<!-- field -->
<h1>{{decisionTitle}}</h1>
<ng-container *ngIf="inFEageRange">
</ng-container>
<ng-container *ngIf="decisionMsg">
  <p class="lead">{{decisionMsg}}</p>
</ng-container>
<ng-container *ngIf="false">
  <div class="col-12 section-title"> <h1>Congratulations</h1></div><p></p>
  <div class="col-12">  <p class="lead">Your application for {{proposedInsured}} is now complete. 
    We are reviewing your information and will send an update to {{agentEmailAddress}} shortly.
    </p></div>
    <div class="col-12"> <p class="lead">Please add "JH eApp do-not-reply@jhancock.com" to your mail contacts and mark emails from this address as "safe" to help ensure 
  there are no delays receiving important updates about your submission</p></div>
  <div class="col-12"><br/>
     <p style="text-align: center;">
    <button (click)="backToMiniPortal()" class=" btn btn-primary mp-btn-small">JH eApp Portal</button>
    </p></div>
</ng-container>
<ng-container *ngIf="(processError || processTimeout) && (!decisionMsgType)">
   <div class="col-12 section-title"> <h1>Congratulations</h1></div><p></p>
   <div class="col-12">
     <p class="lead">Your application for {{proposedInsured}} is now complete.<br/>We are reviewing your information and will send an update to {{agentEmailAddress}} shortly.</p><br/></div>
     <p></p> 
  <div class="col-12"> 
    <p class="lead">Please add &ldquo;JH eApp &lt;do-not-reply@jhancock.com&gt;&rdquo; to your email contacts and mark emails from this address as &ldquo;safe&rdquo; to help ensure there are no delays receiving important updates about your submission. </p>
</div>

<div class="col-12"><br/>
   <p style="text-align: center;"><br/>
  <button (click)="backToMiniPortal()" class=" btn btn-primary mp-btn-small">JH eApp Portal</button>
  </p></div>
</ng-container>
<!--STP-->
<ng-container *ngIf="decisionMsgType && decisionMsgType==1">
  <div class="col-12 section-title"> <h1>Congratulations!</h1></div><p></p>
  <div class="col-12"><p class="lead">{{proposedInsured}}'s application for {{productName}} has been approved for {{faceAmount || '0' | currency:'USD':'symbol':'2.0-0'}} at {{riskClass}} {{smokerStatus}}.</p>
  </div><div class="col-12 section-title"> <h1>Next Steps</h1></div><p></p>
  <div class="col-12">  
     <ul class="lead">
       <li style="margin-bottom: 20pt;"> If {{proposedInsured}} would like to proceed, and if an illustration matching the parameters of the approved case was not already submitted, please run an illustration and email it to <a href="mailto:lifenewbusiness@jhancock.com">lifenewbusiness@jhancock.com</a>.  
</li>
<li style="margin-bottom: 20pt;">Once we receive the illustration, the policy will be issued and electronically delivered to the policy owner within 3-4 business days, providing all requirements, including licensing and appointments, are in good order
</li>
<li style="margin-bottom: 20pt;">You will be able to track your submission via your usual pending case status tools once the case has been set up in our New Business system, which may take up to 24 hours.</li></ul></div>
<div class="col-12"> <p class="lead">If you need to make any changes to what was approved, please contact your case manager.</p>
<p></p></div>
<div class="col-12 "><br/>
  <p style="text-align: center;"><br />
 <button (click)="backToMiniPortal()" class=" btn btn-primary mp-btn-small">JH eApp Portal</button>
 </p></div>
</ng-container>
<!--STP-V-->
<ng-container *ngIf="decisionMsgType && (decisionMsgType==2 || decisionMsgType=='2.5' || decisionMsgType==4)">
  <div class="col-12 section-title"> <h1>Congratulations</h1></div><p></p>
  <div class="col-12"> <p class="lead">Your application for {{proposedInsured}} is now complete.</p><br/></div>
  <div class="col-12 section-title"> <h1>Next Steps</h1></div><p></p>  
  <div class="col-12"> <ul class="lead">
    <li style="margin-bottom: 10pt;">Our New Business team is setting up your case, which may take up to 24 hours. Once the setup is complete, you will be able to track your submission via your usual pending case status tools.</li>
    <li style="margin-bottom: 10pt;">One of our experienced underwriters will be reviewing your submission and will provide an update within two business days. </li>
  </ul></div>
  <div class="col-12"> <p class="lead">If you have any questions, please contact your case manager.</p>
<p></p><br/></div>
<div class="col-12">
  <p style="text-align: center;"><br/>
 <button (click)="backToMiniPortal()" class=" btn btn-primary mp-btn-small">JH eApp Portal</button>
 </p></div>
</ng-container>
<!--FUW-->
<ng-container *ngIf="decisionMsgType && decisionMsgType==3">
  <div class="col-12 section-title"> <h1>Thank you,</h1></div>
  <div class="col-12"> <p class="lead">Your application for {{proposedInsured}} is now complete. </p>
  </div>
  <div class="col-12 section-title"> <h1>Next Steps</h1></div><p></p> 
  <div class="col-12"> <ul class="lead">
    <li style="margin-bottom: 20pt;">Our New Business team is setting up your case, which may take up to 24 hours. Once the setup is complete, you will be able to track your submission via your usual pending case status tools. </li>
    <li style="margin-bottom: 20pt;">Based on the information provided, we will be notifying you of some additional requirements needed to complete the underwriting process. Please also note that a John Hancock-trusted service provider may contact your client directly to obtain the necessary medical requirements.</li>
  </ul></div>
  <div class="col-12">
    <p class="lead">If you have any questions, please contact your case manager.</p>
<p></p></div>
<div class="col-12 centered">
  <p style="text-align: center;">
 <button (click)="backToMiniPortal()" class=" btn btn-primary mp-btn-small">JH eApp Portal</button>
 </p></div>
</ng-container>
<!-- /field -->
  <!-- spinner -->
  <div class="spinner-wrapper text-center" [ngClass]="{'show': processing}">
    <mat-progress-spinner [mode]="'indeterminate'"></mat-progress-spinner>
  </div><!-- /spinner -->
